<template>
  <div>
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">软件销售</div>
      <div class="t-t2box">
        <div class="t-t2">专业 高效 智慧 实现业务快速增长</div>
      </div>
    </div>

    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">业务困境</div>
        <br />
        <div class="t2">致力于优质的服务完美的解决方案</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/products/ruanjian/tubiao1@2x.png" alt="" />
          </div>
          <div class="text1">获客成本高，离职带走顾客难沉淀</div>
          <div class="text2">个人微信加好友，品牌形象不统一，导 购容易被拒绝，客 户不信任， 获客成本高; 员工离职后带走客户，即使 提前由 在职员工二次添加，通</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/ruanjian/tubiao2@2x.png" alt="" />
          </div>
          <div class="text1">营销内容机械重复，沟通效率低</div>
          <div class="text2">没有统一的营销话术、营销素材，多次编辑占用大量时间 工作效率难以提升;销售新人专业能力差， 客户需求响应缓 慢，导致客户易流失</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/ruanjian/tubiao3@2x.png" alt="" />
          </div>
          <div class="text1">免费备案及上架</div>
          <div class="text2">客户身份不清楚，难以做营销决策；缺乏全面的客户画像 工具，仅靠导购员的碎片化记忆手工录 入系统，维度单一 缺乏精准的消费周期管理</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/ruanjian/tubiao4@2x.png" alt="" />
          </div>
          <div class="text1">价格低 更优惠</div>
          <div class="text2">销售沟通过程无质检，敏感行为无审查无预警， 会话无存 档;对于客户群、 会话内容缺少数据分析，运营策略无依据</div>
        </div>
      </div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">核心能力</div>
      </div>

      <!-- 内容 -->
      <div class="box2">
        <div class="item2">
          <div class="b2">
            <img src="@/image/products/ruanjian/tu1@2x.png" alt="" />
          </div>

          <div class="b1">
            <div class="t1">高效获客，快速沉淀企业私域流量池</div>
            <div class="line"></div>

            <div class="t2">为不同渠道匹配二维码，引导客户加企业微信员工好友或入群。自动欢迎语、打 标签。群满自动换群 ，流量不丢失；自动化拉群流程， 根据标</div>
            <div class="t3">活码引流、客群运营、裂变增长</div>
          </div>
        </div>

        <div class="item2">
          <div class="b1">
            <div class="t1">从“流量”转向“留量”</div>
            <div class="line"></div>
            <div class="t2">海量素材模版，营销话术、券、商品可一键推广触达，建立完善的营销过程 管理闭环，提升客户和社群活跃度，提高留存转化。</div>
            <div class="t3">素材管理、文章管理、内容标签、内容类型</div>
          </div>

          <div class="b2">
            <img src="@/image/products/ruanjian/tu2@2x.png" alt="" />
          </div>
        </div>

        <div class="item2">
          <div class="b2">
            <img src="@/image/products/ruanjian/tu3@2x.png" alt="" />
          </div>

          <div class="b1">
            <div class="t1">精准客户画像，精细化运营</div>
            <div class="line"></div>
            <div class="t2">支持客户打标签，客户360画像，多维度了解客户偏好 支持客户在职转接、离 职继承及流失提醒，帮助企业沉淀客户资产</div>
            <div class="t3">客户/群管理、客户画像、客户标签</div>
          </div>
        </div>

        <div class="item2">
          <div class="b1">
            <div class="t1">强化企业风控管理，数据分析助力运营决策</div>
            <div class="line"></div>
            <div class="t2">实时查看成员、客户聊天记录，云端自动保存，支持识别敏感词、会话审查、违 规提醒等，发现问题及时处理，满足行业合法合规要求</div>
            <div class="t3">风控管理、统计分析</div>
          </div>

          <div class="b2">
            <img src="@/image/products/ruanjian/tu4@2x.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">核心优势</div>
      </div>

      <!-- row2内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/products/ruanjian/tubiao5@2x.png" alt="" />

          <div class="t1">打通会员数据</div>
          <div class="t2">深度挖掘客户画像</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/ruanjian/tubiao6@2x.png" alt="" />

          <div class="t1">结合自动化营销工具</div>
          <div class="t2">高效运营促转化</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/ruanjian/tubiao7@2x.png" alt="" />

          <div class="t1">打通导购工作台</div>
          <div class="t2">一站式管理导购业绩</div>
        </div>
      </div>
      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DcuxxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
// 顶部
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/ruanjian/banner@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.row1 {
  height: 800px;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 40px;
    display: flex;
    color: #000;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 95px;
      color: #ffffff;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 380px;

    margin: 80px auto 0 auto;
    box-sizing: border-box;
    padding-left: 110px;
    padding-top: 15px;

    .item1 {
      width: 610px;
      height: 200px;

      position: relative;
      margin-right: 60px;
      margin-bottom: 60px;
      box-shadow: 1px 1px 10px 2px #efefef;

      .img {
        position: absolute;
        top: 50px;
        width: 99px;
        height: 96px;
        margin-left: 15px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        position: absolute;
        top: 50px;
        left: 140px;
        width: 300px;

        color: #333333;
        font-size: 18px;
        letter-spacing: 2px;
      }
      .text2 {
        position: absolute;
        top: 85px;
        left: 140px;
        width: 400px;
        // text-align: center;
        color: #666666;
        font-size: 15px;
        letter-spacing: 2px;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 100px;
    width: 170px;
    left: 850px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 2px;
  }
}

.row2 {
  height: 2000px;
  overflow: hidden;
  position: relative;
  background-color: #f7f8fb;
  margin-bottom: 30px;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box2 {
    margin-top: 100px;
    .item2 {
      display: flex;
      // justify-content: space-around;
      flex-wrap: wrap;
      width: 1400px;
      height: 400px;
      margin: 0 auto 0 auto;
      box-sizing: border-box;

      .b1 {
        width: 50%;
        background-color: #ffffff;

        position: relative;

        .t1 {
          font-size: 24px;
          position: absolute;
          top: 60px;
          left: 70px;

          color: #333333;
        }

        .line {
          position: absolute;
          left: 70px;
          top: 120px;
          height: 2px;
          width: 50px;
          background-color: #4581fb;
        }

        .t2 {
          position: absolute;
          letter-spacing: 1px;
          line-height: 30px;
          font-size: 16px;
          left: 70px;
          top: 150px;
          color: #666666;
        }

        .t3 {
          color: #4581fb;
          position: absolute;
          bottom: 90px;
          font-size: 20px;
          left: 70px;
        }
      }

      .b2 {
        width: 50%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.row3 {
  height: 750px;
  overflow: hidden;

  background-color: #ffffff;
  position: relative;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 90px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 80px auto;
    justify-content: space-around;

    .r2-tiem {
      height: 160px;
      width: 260px;
      position: relative;
      border-radius: 6px;

      img {
        margin-top: 15px;
        margin-left: 20px;
        height: 190px;
        width: 190px;
      }
      .t1 {
        overflow: hidden;
        width: 200px;
        font-size: 21px;
        margin: 20px auto 0 auto;
        text-align: center;
      }
      .t2 {
        margin: 5px auto 0 auto;
        font-size: 21px;
        text-align: center;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    // position: absolute;
    bottom: 100px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 4px;
    margin: 260px auto;
  }
}
</style>
